import { inject, Injectable, signal } from '@angular/core';
import { Auth } from '@synegen/utility';

@Injectable({ providedIn: 'root' })
export class FileUploaderService {

  #auth: Auth = inject(Auth);

  buttonVisible = signal(false);
  visible = signal(false);

  setButtonVisible = (target: boolean) => {
    this.buttonVisible.set(
      this.#auth.hasAuthority('ems:datalake:view') &&
      target
    );
  };

  open() {
    this.visible.set(true);
  }

  close() {
    this.visible.set(false);
  }

  toggle() {
    this.visible.set(!this.visible());
  }
}
